import { GridColumn } from 'api/endpoints';

export function processGridColumns(gridColumns?: GridColumn[]): GridColumn[] {
  if (!gridColumns) return [];
  return gridColumns.filter((gc) => !!gc.displayName);
}
